import React, {useState, useEffect} from 'react';
import {Translate} from '../../components/translations';
import {TrackRegistration} from '../../helpers/trackingEvents';
import {VALID_PASSWORD_REGEX} from '../../helpers/constants';
import {navigate} from 'gatsby';
import {
  UserRegistrationFormState,
  UserRegistrationSecondaryState,
  UserRegistrationData,
  GatsbyPageProps,
} from '../../types';
import {
  setUserToken,
  setUserHash,
  setNewUser,
  setDeviceKey,
  setRefreshToken,
  getRawCookie,
  setRawCookie,
} from '../../helpers';
import {useMutation} from '@apollo/react-hooks';
import {USER_REGISTRATION} from '../../graphql/mutations';
import googleIcon from '../../../static/google-icon.svg';
import Message from '../messages';
import Checkbox from '../customCheckbox';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import ChangeTwoFactor from '../changeTwoFactor';
import './styles.scss';
import {eyeIcon} from '../../images/svgIcons';

// export const getItem = () => {
//   return !!localStorage.getItem('packageInfo');
// };

const Registration = ({
  location,
  setShowLogin,
  setShowRegistration,
  promoCode,
  setHandleCloseRegModal,
}: GatsbyPageProps): JSX.Element => {
  const [registrationMutation, {loading}] = useMutation<UserRegistrationData>(USER_REGISTRATION);
  const [referralCode, setReferral] = useState('');

  const [formData, setFormData] = useState<UserRegistrationFormState>({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    promoCode: promoCode || '',
    referralCode: '',
  });

  const [passwordMessage, setPasswordMessage] = useState(false);
  const [showTwoFactor, setShowTwoFactor] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [limitExceed, setLimitExceed] = useState(false);

  const redirects = () => {
    if (localStorage.getItem('checkout-data')) {
      navigate('/pricing/checkout/');
    } else if (location?.state?.navigatePath) {
      navigate(location.state.navigatePath);
    } else {
      if (window.location.host.includes('localhost')) {
        window.location.href = 'http://localhost:3000';
      } else if (window.location.host.includes('37.186.119.181')) {
        window.location.href = 'http://37.186.119.181:3279';
      } else {
        window.location.href = 'https://dash.hexowatch.com/hexowatch';
      }
    }
  };

  useEffect(() => {
    if (location) {
      if (location.state && location.state.email) {
        setFormData({...formData, ['email']: location.state.email});
      }
    }
    const urlParams = new URLSearchParams(window.location.search);
    let referral = urlParams.get('referralCode');
    if (referral) {
      if (referral[referral.length - 1] === '/') {
        referral = referral.slice(0, -1);
        setFormData({...formData, referralCode: referral});
        setReferral(referral);
        setRawCookie('referralCode', referral);
      }
    }
  }, [location]);

  useEffect(() => {
    const ref = getRawCookie('referralCode');
    ref && setReferral(ref);
  }, []);

  const [secondaryData, setSecondaryData] = useState<UserRegistrationSecondaryState>({
    checked: false,
    error: false,
    errorMessage: '',
    isModalOpen: false,
    sessionToken: '',
  });

  const fieldChangeHandler = (event: React.SyntheticEvent): void => {
    const target = event.target as HTMLInputElement;
    const {value, name} = target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const checkHandler = (): void =>
    setSecondaryData({
      ...secondaryData,
      checked: !secondaryData.checked,
    });

  const submitHandler = async () => {
    if (formData.password.length > 64) {
      setLimitExceed(true);
      setPasswordMessage(false);
      return;
    }
    if (VALID_PASSWORD_REGEX.test(formData.password)) {
      setPasswordMessage(false);
      setLimitExceed(false);
    } else {
      setLimitExceed(false);
      setPasswordMessage(true);
      return;
    }

    setSecondaryData({...secondaryData, error: false, errorMessage: ''});
    if (secondaryData.checked) {
      TrackRegistration(formData);
      const {data} = await registrationMutation({
        variables: {
          ...formData,
          sessionToken: secondaryData.sessionToken,
        },
      });

      if (data) {
        const {
          UserOps: {
            registration: {error, message, token, hash, device_key, refresh_token},
          },
        } = data;
        if (error) {
          setSecondaryData({
            ...secondaryData,
            error: true,
            errorMessage: message,
          });
        } else {
          setUserToken(token);
          setUserHash(hash);
          setDeviceKey(device_key);
          setRefreshToken(refresh_token);
          setNewUser(true);
          redirects();
          // if (Math.round(Math.random())) {
          //   // setHandleCloseRegModal(true);
          //   setShowTwoFactor(true);
          // } else {
          //   redirects();
          // }
        }
      }
    } else {
      setSecondaryData({
        ...secondaryData,
        error: true,
        errorMessage: 'Please agree to the Terms of Service',
      });
    }
  };

  const toLogin = () => {
    // setShowLogin(true);
    // setShowRegistration(false);
    navigate('/login');
  };

  return (
    <div className="registration-block">
      {showTwoFactor ? (
        <ChangeTwoFactor />
      ) : (
        <>
          <h4 className="title">Create your account</h4>
          <button
            className="gmail-btn"
            onClick={() => {
              window.location.href = `https://api.hexowatch.com/v2/app/social-callback/hexowatch/google?referralCode=${referralCode}${
                localStorage.getItem('checkout-data')
                  ? '&redirect=pricing/checkout'
                  : location?.state?.navigatePath
                  ? `&redirect=${location.state.navigatePath.slice(1)}`
                  : ''
              }&deviceKey=${getRawCookie('device_key') || ''}`;
            }}
          >
            <img src={googleIcon} alt="Login with Google" width={30} /> <span>Sign Up with Google</span>
          </button>
          <div className="or-div">
            <div>
              <Translate name="or" />
            </div>
            <hr />
          </div>
          <div className="forms">
            <div className="wrapper">
              <div className="form-item">
                <label>First Name</label>
                <input
                  style={
                    secondaryData.error && secondaryData.errorMessage === 'INVALID_FIRSTNAME'
                      ? {
                          border: '1px',
                          borderColor: '#FB6F6F',
                          borderStyle: 'solid',
                        }
                      : {}
                  }
                  required
                  placeholder={'First Name'}
                  type="text"
                  name="firstName"
                  onChange={fieldChangeHandler}
                  value={formData.firstName}
                  maxLength={255}
                />
              </div>
              <div className="form-item">
                <label>Last Name</label>
                <input
                  style={
                    secondaryData.error && secondaryData.errorMessage === 'INVALID_LASTNAME'
                      ? {
                          border: '1px',
                          borderColor: '#FB6F6F',
                          borderStyle: 'solid',
                        }
                      : {}
                  }
                  required
                  placeholder={'Last Name'}
                  type="text"
                  name="lastName"
                  onChange={fieldChangeHandler}
                  value={formData.lastName}
                  maxLength={255}
                />
              </div>
            </div>
            <div className="form-item">
              <label>Email</label>
              <input
                style={
                  secondaryData.error &&
                  (secondaryData.errorMessage === 'INVALID_EMAIL' ||
                    secondaryData.errorMessage === 'USER_ALREADY_EXISTS')
                    ? {border: '1px', borderColor: 'red', borderStyle: 'solid'}
                    : {}
                }
                required
                placeholder={'Email'}
                type="email"
                name="email"
                onChange={fieldChangeHandler}
                value={formData.email}
                maxLength={320}
              />
            </div>
            <div className="form-item position-relative password-form-reg">
              <label>Password</label>
              <input
                style={
                  secondaryData.error && secondaryData.errorMessage === 'PASSWORD_NOT_SECURE'
                    ? {
                        border: '1px',
                        borderColor: '#FB6F6F',
                        borderStyle: 'solid',
                      }
                    : {}
                }
                required
                placeholder={'Password (minimum 8 symbols)'}
                type={!showPassword ? 'password' : 'text'}
                name="password"
                onChange={fieldChangeHandler}
                value={formData.password}
              />
              <span
                className={`eye-icon-reg ${showPassword ? ' active' : ''}`}
                onClick={() => setShowPassword(!showPassword)}
              >
                {eyeIcon}
              </span>
            </div>
            <div className="form-item">
              <label>Referral code</label>
              <input
                // style={{ border: "none" }}
                placeholder={'Referral code (optional)'}
                type="text"
                name="referralCode"
                onChange={fieldChangeHandler}
                value={formData.referralCode}
                maxLength={255}
              />
            </div>
            {/*<div className="form-item">
          <input
            placeholder={"Promo Code"}
            type="text"
            name="promoCode"
            onChange={fieldChangeHandler}
            value={formData.promoCode}
          />
            </div>*/}
            <div className={secondaryData.errorMessage || passwordMessage ? 'visible' : 'invisible'}>
              <Message
                type="error"
                text={
                  (secondaryData.errorMessage &&
                    (<Translate name={secondaryData.errorMessage.trim()} /> || secondaryData.errorMessage.trim())) ||
                  'Your password should consist of at least 8 characters including at least 1 digit, 1 capital letter and at least 1 special character'
                }
              />
            </div>

            {limitExceed && <Message type="error" text="Maximum allowed password length is 64 characters." />}
          </div>
          <div className="terms">
            <div className="toggle-checkbox">
              <Checkbox checked={secondaryData.checked} click={checkHandler} />
              <span className="text">I agree to the&nbsp;</span>
              <span className="terms-text">
                <a href="https://hexowatch.com/terms-of-use" target="_blank">
                  Terms of Service
                </a>
              </span>{' '}
              <span style={{color: 'red'}}>*</span>
            </div>
          </div>
          <div className="submit-block">
            <button className="submit-btn" onClick={submitHandler}>
              {loading ? <FontAwesomeIcon icon={faSpinner} className="button-loading" /> : <Translate name="SIGN_UP" />}
            </button>
          </div>
          <div className="sign-in">
            <span className="text">
              <Translate name="ALREADY_MEMBER" />
              &nbsp;
            </span>
            <span className="sign-in-text" onClick={toLogin}>
              <Translate name="LOG_IN" />
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default Registration;
